import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { OrderLocation } from '@ml/orders/types/classes';
import { Location } from '@ml/locations/types';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'ml-locations-move-dialog',
  template: `
    <div class="container">
      <div class="mat-title">
        {{ 'move-locations' | translate | titlecase }}
      </div>

      <mat-form-field class="full-width">
        <mat-label>{{ 'location' | translate | titlecase }}</mat-label>
        <input
          matInput
          value="{{ orderLocationName(data.orderLocationToMove) }}"
          disabled
        />
      </mat-form-field>

      <form [formGroup]="form">
        <mat-form-field class="full-width">
          <mat-label>{{ 'new-position' | translate | titlecase }}</mat-label>
          <input matInput formControlName="newPosition" required />
          <mat-error *ngIf="newPositionControl.hasError('required')">
            {{ 'this-field' | translate | titlecase }} {{ 'is' | translate }}
            <strong>{{ 'required' | translate }}</strong>
          </mat-error>
          <mat-error *ngIf="newPositionControl.hasError('min')">
            {{ 'new-position-too-low' | translate: { value: 0 } }}
          </mat-error>
          <mat-error *ngIf="newPositionControl.hasError('max')">
            {{
              'new-position-too-high'
                | translate: { value: data.orderLocations.length }
            }}
          </mat-error>
        </mat-form-field>
      </form>

      <div fxLayout fxLayoutAlign="end" class="margin-top-16">
        <button mat-button (click)="onToFirst()">
          {{ 'to-first' | translate | titlecase }}
        </button>
        <button mat-button (click)="onToLast()">
          {{ 'to-last' | translate | titlecase }}
        </button>
        <button mat-button (click)="onConfirm()">
          {{ 'confirm' | translate | titlecase }}
        </button>
        <button mat-button (click)="onClose()">
          {{ 'cancel' | translate | titlecase }}
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./locations-move-dialog.component.scss']
})
export class LocationsMoveDialogComponent {
  form: FormGroup;
  orderLocationToMove: OrderLocation;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      orderLocationToMove: OrderLocation;
      orderLocations: OrderLocation[];
    },
    private dialogRef: MatDialogRef<LocationsMoveDialogComponent>,
    private fb: FormBuilder
  ) {
    this.form = this.createForm(this.data.orderLocations.length);
  }

  get newPositionControl() {
    return this.form.get('newPosition');
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(this.newPositionControl.value - 1);
  }

  onToFirst() {
    this.dialogRef.close(0);
  }

  onToLast() {
    this.dialogRef.close(this.data.orderLocations.length);
  }

  orderLocationName(orderLocation: OrderLocation): string {
    const location = orderLocation.location as Location;
    return location.name;
  }

  createForm(amountOfOrderLocations: number): FormGroup {
    return this.fb.group({
      newPosition: [
        null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(amountOfOrderLocations)
        ])
      ]
    });
  }
}
